<div class="dashboard-actions">
    <button type="button"
        class="dashboard-actions-icon-wrapper"
        (click)="showDetail()"
        matTooltip="View Details"
        matTooltipPosition="above">
        <span class="fal fa-file-spreadsheet"></span>
    </button>
    <span *ngIf="divider" class="dashboard-actions-icon-divider"></span>
    <button 
        type="button"
        class="dashboard-actions-icon-wrapper"
        (click)="getDashboardTileEmail(tooltip)"
        [matTooltip]="toolTipStatus"
        #tooltip="matTooltip"
        [matTooltipHideDelay]="delayValue"
        matTooltipPosition="above">
        <span class="fal fa-envelope"></span>
    </button>
</div>